import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRacketIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 43.076,
	height: 65.592,
	viewBox: "0 0 43.076 65.592",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_1792",
				"data-name": "Rectangle 1792",
				width: 8.612,
				height: 8.612,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-2",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_1793",
				"data-name": "Rectangle 1793",
				width: 6.447,
				height: 2.801,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-3",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_1794",
				"data-name": "Rectangle 1794",
				width: .01,
				height: .019,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-4",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_1795",
				"data-name": "Rectangle 1795",
				width: 8.416,
				height: 3.498,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-5",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_1796",
				"data-name": "Rectangle 1796",
				width: 7.921,
				height: 4.5,
				fill: "none"
			})
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_6094",
		"data-name": "Group 6094",
		transform: "translate(16365.986 7531.104)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8596",
				"data-name": "Path 8596",
				d: "M132.361,64.054a7.749,7.749,0,0,0,7.388,5.415H152.53a7.749,7.749,0,0,0,7.388-5.415Z",
				transform: "translate(-16490.588 -7547.358)",
				fill: "#0076b3"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8597",
				"data-name": "Path 8597",
				d: "M152.713,75.608h-8.151A1.559,1.559,0,0,1,143,74.049V71.311h11.269v2.738a1.559,1.559,0,0,1-1.559,1.559",
				transform: "translate(-16493.289 -7549.199)",
				fill: "#5c5c5f"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_1791",
				"data-name": "Rectangle 1791",
				width: 11.27,
				height: 1.413,
				transform: "translate(-16350.286 -7477.889)",
				fill: "#49484b"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8598",
				"data-name": "Path 8598",
				d: "M146.063,77.069a7.7,7.7,0,0,0,.958,4.166l2.052,3.691a.433.433,0,0,0,.757,0l2.052-3.691a7.7,7.7,0,0,0,.958-4.166Z",
				transform: "translate(-16494.063 -7550.661)",
				fill: "#ec671c"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8599",
				"data-name": "Path 8599",
				d: "M147.3,77.069a6.743,6.743,0,0,0,.842,3.716l1.621,2.916,1.622-2.916a6.744,6.744,0,0,0,.842-3.716Z",
				transform: "translate(-16494.375 -7550.661)",
				fill: "#f3e600"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8600",
				"data-name": "Path 8600",
				d: "M138.4,67.6a2.843,2.843,0,0,0,2.625,1.866H153.98a2.826,2.826,0,0,0,2.529-1.62,6.084,6.084,0,0,0,.631-2.588V64.054H138v1.207a7.024,7.024,0,0,0,.4,2.34",
				transform: "translate(-16492.02 -7547.358)",
				fill: "#0098d2"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8601",
				"data-name": "Path 8601",
				d: "M136.19,46.074a18.533,18.533,0,0,0,.575-3.92,47.1,47.1,0,0,1-.89-7.48c-.038-.146-.077-.29-.118-.435a21.122,21.122,0,0,0-2.752-5.878,25.887,25.887,0,0,0-11.04,21.205v8.685l0,0a27.727,27.727,0,0,1,10.2-4.16,20.6,20.6,0,0,0,4.031-8.02",
				transform: "translate(-16487.949 -7538.3)",
				fill: "#1da193"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8602",
				"data-name": "Path 8602",
				d: "M135.626,62.844h0",
				transform: "translate(-16491.416 -7547.051)",
				fill: "#49484b"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8603",
				"data-name": "Path 8603",
				d: "M128.345,53.51a7.734,7.734,0,0,0,.3,2.107,37.317,37.317,0,0,1,5.136-1.525,20.6,20.6,0,0,0,4.031-8.02,18.572,18.572,0,0,0,.575-3.92,47,47,0,0,1-.89-7.48c-.038-.146-.077-.29-.118-.434a21.117,21.117,0,0,0-2.752-5.879,25.879,25.879,0,0,0-5.358,5.038,50.219,50.219,0,0,0-.922,9.579Z",
				transform: "translate(-16489.568 -7538.3)",
				fill: "#138959"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8604",
				"data-name": "Path 8604",
				d: "M160.427,46.074a18.58,18.58,0,0,1-.575-3.92,47.012,47.012,0,0,0,.89-7.48c.038-.146.077-.29.118-.435a21.122,21.122,0,0,1,2.752-5.878,25.887,25.887,0,0,1,11.04,21.205v8.685l0,0a27.727,27.727,0,0,0-10.2-4.16,20.6,20.6,0,0,1-4.031-8.02",
				transform: "translate(-16497.564 -7538.3)",
				fill: "#1da193"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8605",
				"data-name": "Path 8605",
				d: "M166.024,62.844h0",
				transform: "translate(-16499.131 -7547.051)",
				fill: "#49484b"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8606",
				"data-name": "Path 8606",
				d: "M169.891,53.51a7.734,7.734,0,0,1-.3,2.107,37.319,37.319,0,0,0-5.136-1.525,20.6,20.6,0,0,1-4.031-8.02,18.574,18.574,0,0,1-.575-3.92,47,47,0,0,0,.89-7.48c.038-.146.077-.29.118-.434a21.137,21.137,0,0,1,2.752-5.879,25.88,25.88,0,0,1,5.358,5.038,50.22,50.22,0,0,1,.922,9.579Z",
				transform: "translate(-16497.564 -7538.3)",
				fill: "#138959"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8607",
				"data-name": "Path 8607",
				d: "M146.018,0h0a50.232,50.232,0,0,0-14.137,34.934V45.469a7.746,7.746,0,0,0,7.746,7.746h12.782a7.746,7.746,0,0,0,7.746-7.746V34.934A50.232,50.232,0,0,0,146.018,0",
				transform: "translate(-16490.467 -7531.104)",
				fill: "#64d89b"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8608",
				"data-name": "Path 8608",
				d: "M158.442,19.01A50.224,50.224,0,0,0,146.9,0a50.214,50.214,0,0,0-11.542,19.01Z",
				transform: "translate(-16491.348 -7531.104)",
				fill: "#138959"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8609",
				"data-name": "Path 8609",
				d: "M147.571,29.446h0A9.568,9.568,0,0,0,138,39.014V55.272H157.14V39.014a9.569,9.569,0,0,0-9.568-9.568",
				transform: "translate(-16492.02 -7538.576)",
				fill: "#def1fb"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8610",
				"data-name": "Path 8610",
				d: "M155.774,40.287a7.5,7.5,0,1,0-7.5,7.5,7.5,7.5,0,0,0,7.5-7.5",
				transform: "translate(-16492.725 -7539.424)",
				fill: "#138959"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8611",
				"data-name": "Path 8611",
				d: "M154.95,40.712a6.25,6.25,0,1,0-6.251,6.251,6.25,6.25,0,0,0,6.251-6.251",
				transform: "translate(-16493.148 -7539.848)",
				fill: "#64d89b"
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_5811",
				"data-name": "Group 5811",
				transform: "translate(-16348.754 -7503.443)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_5810",
					"data-name": "Group 5810",
					clipPath: "url(#clip-path)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_8612",
						"data-name": "Path 8612",
						d: "M153.667,41.373a4.306,4.306,0,1,0-4.306,4.307,4.306,4.306,0,0,0,4.306-4.307",
						transform: "translate(-145.055 -37.066)",
						fill: "#14172c"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_5814",
				"data-name": "Group 5814",
				transform: "translate(-16348.479 -7503.443)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_5813",
					"data-name": "Group 5813",
					clipPath: "url(#clip-path-2)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_8613",
						"data-name": "Path 8613",
						d: "M145.424,39.867l6.447-2.06c-.081-.055-.166-.1-.251-.154-.046-.027-.09-.054-.137-.08-.113-.061-.23-.118-.349-.169l-.01,0a4.3,4.3,0,0,0-5.7,2.466",
						transform: "translate(-145.424 -37.066)",
						fill: "#49484b"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_5817",
				"data-name": "Group 5817",
				transform: "translate(-16340.656 -7501.175)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_5816",
					"data-name": "Group 5816",
					clipPath: "url(#clip-path-3)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_8614",
						"data-name": "Path 8614",
						d: "M155.912,40.112c-.007-.013-.006-.01.005.013h0l-.006-.012",
						transform: "translate(-155.907 -40.105)",
						fill: "#49484b"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_5820",
				"data-name": "Group 5820",
				transform: "translate(-16348.715 -7501.156)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_5819",
					"data-name": "Group 5819",
					clipPath: "url(#clip-path-4)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_8615",
						"data-name": "Path 8615",
						d: "M145.334,43.629l8.189-2.616a5.676,5.676,0,0,0-.348-.882l-8.068,2.577a4.3,4.3,0,0,0,.226.922",
						transform: "translate(-145.108 -40.131)",
						fill: "#49484b"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_5823",
				"data-name": "Group 5823",
				transform: "translate(-16348.063 -7499.331)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_5822",
					"data-name": "Group 5822",
					clipPath: "url(#clip-path-5)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_8616",
						"data-name": "Path 8616",
						d: "M153.9,42.768c0-.065-.007-.128-.01-.191v0l-7.911,2.527a4.3,4.3,0,0,0,7.726-1.056c.016-.052.028-.107.042-.16.022-.084.047-.166.064-.251a4.292,4.292,0,0,0,.089-.87v0",
						transform: "translate(-145.982 -42.577)",
						fill: "#49484b"
					})
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8618",
				"data-name": "Path 8618",
				d: "M151.5,21.2a1.027,1.027,0,1,0-1.027,1.027A1.027,1.027,0,0,0,151.5,21.2",
				transform: "translate(-16494.924 -7536.224)",
				fill: "#64d89b"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8619",
				"data-name": "Path 8619",
				d: "M142.066,21.2a1.027,1.027,0,1,0-1.027,1.027,1.027,1.027,0,0,0,1.027-1.027",
				transform: "translate(-16492.529 -7536.224)",
				fill: "#64d89b"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8620",
				"data-name": "Path 8620",
				d: "M160.941,21.2a1.027,1.027,0,1,0-1.027,1.027,1.027,1.027,0,0,0,1.027-1.027",
				transform: "translate(-16497.318 -7536.224)",
				fill: "#64d89b"
			})
		]
	})]
});
export { SvgRacketIcon as ReactComponent };
